import {
  EntityList,
  EntityListProps,
  renderDate,
  renderPath,
  renderPersona,
  renderStatusIcon,
} from 'components/EntityList'
import { Proving, User } from 'gql.generated'
import { Box } from 'grid'
import {
  ConstrainMode,
  PersonaSize,
  SelectionMode,
  Stack,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'
import { maintenanceHeadDetails } from './AssignedWorkerView'

export type AssignedWorkerListProps = EntityListProps<maintenanceHeadDetails>

export const AssignedWorkerList: React.FunctionComponent<
  AssignedWorkerListProps
> = ({ items, ...props }) => {
  const { t } = useTranslation()
  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('person', {
        onRender: (item: maintenanceHeadDetails, i, col) => {
          return (
            <Stack horizontal={true}>
              <Stack.Item>
                {renderPersona({
                  size: PersonaSize.size24,
                })(item, i, col)}
              </Stack.Item>
            </Stack>
          )
        },
        isGrouped: true,
        minWidth: 155,
        ungroupable: true,
        isSorted: true,
        getGroupValue: (item: maintenanceHeadDetails) => item.name,
      }),
      fieldColumn('status', {
        onRender: renderStatusIcon,
        getGroupValue: (item: Proving) => t(`enum.status.${item.status}`),
        minWidth: 40,
        maxWidth: 60,
        ungroupable: true,
      }),
      fieldColumn('dateFrom', {
        onRender: renderDate,

        ungroupable: true,
      }),
      fieldColumn('dateTo', {
        onRender: renderDate,
        ungroupable: true,
      }),
      fieldColumn('provingTitle', {
        ungroupable: true,
      }),
      fieldColumn('responsible', {
        onRender: (item, i, col) => {
          return (
            <div key={i}>
              {item.responsible.map((user: User, a: any) => {
                return (
                  <Box key={a} style={{ whiteSpace: 'pre-line' }}>
                    {user.name}
                  </Box>
                )
              })}
            </div>
          )
        },
        getGroupValue: (item: Proving) => {
          let result = ''
          if (item.responsible) {
            item.responsible.forEach((user: User) => {
              result = `${result} ${user.name}`
            })
          }
          return result
        },
        ungroupable: true,
        minWidth: 105,
      }),
      fieldColumn('department', { ungroupable: true }),
      fieldColumn('provingId', {
        onRender: renderPath,
        ungroupable: true,
      }),
    ],
    [fieldColumn, t]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      sortHighestGroup={true}
      {...props}
    />
  )
}
